import { omit, cloneDeep } from 'lodash';
import { createSpeakingTaskType } from '../../createTaskType';
import { createSpeakingStoryItem } from "@dyl/task-types/sharedLogic/speakingItemCreators";
import SpeakingGenericEditor from "@dyl/task-types/sharedLogic/SpeakingGenericEditor";
import withProps from "@dyl/utils/withProps";

export default createSpeakingTaskType({
    id: 'tell_the_story',
    label: 'Tell The Story',
    skill: 'speaking',
    v2: true,
    hasRubric: true,

    editor: withProps(SpeakingGenericEditor, { disableTargets: true, includeContextAudioField: true }),
    createItemsTemplate: () => [
        createSpeakingStoryItem({ isExample: true }),
        createSpeakingStoryItem(),
        createSpeakingStoryItem(),
        createSpeakingStoryItem(),
        createSpeakingStoryItem({ isSummary: true })
    ],

    convertToUploadFormat: (task, { isNew }) => {
        task = cloneDeep(task);
        task.items = task.items.map(item => {
            if (item?.image_id === '' || item?.image_id === null)
                delete item.image_id;

            item.backups = item?.backups?.map(backup => omit(backup, 'item_id'));
            item.answers = item?.answers?.map(a => {
                if (a?.image_id === '' || a?.image_id === null)
                    delete a.image_id;
                if (!a?.coordinates?.top && !a?.coordinates?.left)
                    delete a.coordinates;
                return a;
            });
            return item;
        })
        return task;
    },

    hasEndAudio: true,
    backgroundImages: {
        count: 1,
        configs: [
            {
                label: 'Context Image'
            }]
    }
});